import React, {PureComponent} from "react"
import {Row, Col} from "@irati/ui/src/Layout"
import {LoginActiveSession} from "@irati/types"
import Card from "@irati/ui/src/Layout/Card"
import {H1, H4} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import sessionService from "@irati/auth/services/login"
import type {ZenObservable} from "zen-observable"

import authentication from "@irati/auth"
import ActiveSession from "../../components/ActiveSession"

interface Props {}

interface State {
  load: Promise<any> | null
  sessions: LoginActiveSession[]
}

export default class Security extends PureComponent<Props, State> {
  sessionSub?: ZenObservable.Subscription

  state: State = {
    load: hangPromise(),
    sessions: []
  }

  componentDidMount() {
    this.sessionSub = sessionService.watchActive(authentication.user().uuid, {fetchPolicy: "network-only"}).subscribe((data) => {
      const {loginActiveSessions} = data.data
      const sessions = this.filterCurrentSessionToTop(loginActiveSessions)
      this.setState({sessions, load: null})
    })
  }

  componentWillUnmount() {
    if (this.sessionSub) {
      this.sessionSub.unsubscribe()
    }
  }

  filterCurrentSessionToTop(sessions: LoginActiveSession[]) {
    const currentSession = sessions.filter((item) => item.isCurrent)
    const rest = sessions
      .filter((item) => !item.isCurrent)
      .sort((a: LoginActiveSession, b: LoginActiveSession) => {
        return Date.parse(b.refreshedAt || b.createdAt) - Date.parse(a.refreshedAt || a.createdAt)
      })

    return [...currentSession, ...rest]
  }

  render() {
    return (
      <Card tiny noBorder>
        <H1 marginBottom={4}>
          <FormattedMessage id="account.security.header" />
        </H1>
        <Row>
          <Col md={12}>
            <H4 marginBottom={4}>
              <FormattedMessage id="account.security.sessions.header" />
            </H4>
            <Loading load={this.state.load}>
              {this.state.sessions.map((session) => (
                <ActiveSession key={session.uuid} session={session} />
              ))}
            </Loading>
          </Col>
        </Row>
      </Card>
    )
  }
}
